import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanoAcaoService } from "./../../../services/plano-acao.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoModel, IRecomendacaoOsaExecucaoMatrizModel } from '../../../models/plano-acao-model';

@Component({
  selector: 'app-plano-acao-imprimir',
  templateUrl: './plano-acao-imprimir.component.html',
  styleUrls: ['./plano-acao-imprimir.component.scss']
})
export class PlanoAcaoImprimirComponent implements OnInit {

  public model: IPlanoAcaoModel = {} as IPlanoAcaoModel;
  public id: number = 0;
  public dataHoje: Date = this.truncateDate(new Date());
  public minuta: boolean = false;

  constructor(
    public matDialog: MatDialog,
    public route: ActivatedRoute,
    private planoAcaoService: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoImprimirComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.id = data?.id;
  }

  ngOnInit(): void {
    this.getImprimirPlanoAcao(this.id);
  }

  getImprimirPlanoAcao(Id: number) {

    this.planoAcaoService
      .imprimirPorId(this.id)
      .then((res) => {
        this.model = res.dados;
        this.minuta = this.model.status.codigo == 1 || this.model.status.codigo == 2 || this.model.status.codigo == 3;
      })
      .catch((err) => {
      })
  }

  onImprimir() {
    // opcional — pode deixar vazio, o print já é interno
  }

  onFechar() {
    this.dialogRef.close();
  }

  private truncateDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  getRowSpanAcao(item: IAcaoPlanoAcaoModel): number {
    if (!item.recomendacoes || item.recomendacoes.length === 0) {
      return 1;
    }

    let total = 0;

    item.recomendacoes.forEach((r: IAcaoPlanoAcaoRecomendacaoModel) => {
      if (r.recomendacao.itensVinculados && r.recomendacao.itensVinculados.length > 0) {
        total += r.recomendacao.itensVinculados.length;
      } else {
        total += 1;
      }
    });

    return total;
  }


  getRowSpanRecomendacao(r: any): number {
    const qtd = r.recomendacao?.itensVinculados?.length;
    return qtd && qtd > 0 ? qtd : 1;
  }

  getStatusClass(codigo: number): string {
    switch (codigo) {
      case 1: return 'bg-gray-dark';
      case 2: return 'bg-info';
      case 3: return 'bg-warning';
      case 4: 
      case 5: return 'bg-danger';
      case 6: 
      case 7: return 'bg-success';
      case 8: return 'bg-info';
      case 9: return 'bg-primary';
      case 10: return 'bg-atendida-parcialmente';
      case 11: return 'bg-warning';
      case 12: return 'bg-success';
      case 13: return 'bg-gray-dark';
      default: return 'bg-secondary';
    }
  }

}

